import { createFileRoute } from '@tanstack/react-router'
import { Reports } from '@/features/reports'
import { reportSearchSchema } from '@/features/reports/navigation'

export const Route = createFileRoute('/_authenticated/reports/')({
  validateSearch: reportSearchSchema,
  component: Reports,
})
